<template>
  <div
    class="w-full h-full bg-racq-true-white fixed z-[1000] top-0 left-0 overflow-hidden"
    :class="{ 'opacity-75': applyOpacity }"
  >
    <DotLottieVue
      autoplay
      class="absolute top-[50%] left-[50%] translate-y-[-50%] translate-x-[-50%]"
      style="width: 50px; height: 50px"
      loop
      :data="loadingIconData"
    />
  </div>
</template>
<script setup lang="ts">
import { DotLottieVue } from '@lottiefiles/dotlottie-vue';
import loadingData from '@/assets/animated-icons/Loading_spinner_blue.json';
const loadingIconData = loadingData as any;

const props = withDefaults(
  defineProps<{
    applyOpacity?: boolean;
  }>(),
  {
    applyOpacity: false,
  }
);
</script>
